import { environment } from 'src/environments/environment';

import { ReplacementOptions, ReplacementBracesRegime } from 'src/app/shared/models/stringUtils.models';

const defaultReplacementOptions: ReplacementOptions = {
  braces: ReplacementBracesRegime.doubleBraces,
  replacePredicate: true
};

export const replaceInPattern = (
  template: string,
  data: object,
  options: ReplacementOptions = defaultReplacementOptions
): string => {
  const replacementOptions = Object.assign({}, defaultReplacementOptions, options);
  const { braces, replacePredicate } = replacementOptions;

  if (braces === ReplacementBracesRegime.noBraces) {
    let response = template;
    Object.keys(data).forEach(k => {
      response = response.split(k).join(data[k]);
    });
    return response;
  }

  const pattern = braces === ReplacementBracesRegime.singleBraces ? /{(.*?)}/g : /{{(.*?)}}/g;

  return template.replace(pattern, (match, token) => {
    const replacementValue = data[token];
    if (typeof replacePredicate === 'function' && replacePredicate(match, token, replacementValue)) {
      return '';
    }

    if (replacementValue) {
      return replacementValue;
    }

    if (replacePredicate === true) {
      return '';
    }

    return match;
  });
};

export const getActionableStringParts = (template: string, actionIds: string[]): any[] => {
  const pattern = /{{(.*?)}}/g;
  const stringParts = template.split(pattern).filter(val => val);
  const parts = [];
  let skipNext = false;

  stringParts.forEach((stringPart, i) => {
    if (skipNext || stringPart.includes('LinkEnd')) {
      skipNext = false;
      return;
    }

    let isActionableString = false;
    actionIds.forEach(actionablePartId => {
      if (stringPart.includes(actionablePartId)) {
        isActionableString = true;
        return;
      }
    });

    if (isActionableString) {
      const value = stringParts[i + 1];
      const key = stringPart.substring(environment.localizationPlaceholdersPrefix.length, stringPart.length);
      parts.push({ [key]: value });
      skipNext = true;
      return;
    }

    parts.push(stringPart);
  });

  return parts;
};

export const areEqualTrimmed = (strOne: string, strTwo: string): boolean => {
  return strOne.trim() == strTwo.trim();
};

export const stringCapitalize = (lowerCaseString: string): string => {
  const firstLetter = lowerCaseString[0];
  return `${firstLetter.toUpperCase()}${lowerCaseString.slice(1)}`;
};

export const getEndingSeparator = (str: string, separators: string[]): string => {
  let endSeparator = '';
  separators.forEach(separator => {
    if (str.endsWith(separator)) {
      endSeparator = separator;
      return;
    }
  });

  return endSeparator;
};
